module.exports = __webpack_public_path__ + "static/hack-d858d7afae48890818e8379b1c71d1f5.gif";